import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ErrorFormatter} from '@core/helpers/error-formatter';
import {CrudBuilderConfig} from '@core/components/crudbuilder/models/crud-builder-config';

@Component({
  selector: 'app-wizard-crudbuilder',
  templateUrl: './wizard-crudbuilder.component.html',
  styleUrls: ['./wizard-crudbuilder.component.scss'],
})
export class WizardCrudbuilderComponent implements OnInit {
  @Input('step') step = 1;
  @Input('config') passedConfig: CrudBuilderConfig = new CrudBuilderConfig();
  @Input('model') model = {};

  @Output() saveBeforeCreatingForm: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  add() {
    const lastForm = this.passedConfig.models[this.passedConfig.models.length - 1];

    const model = this.passedConfig.editPreprocess({});
    if (lastForm.hasOwnProperty('id')) {
      this.passedConfig.models.push(model);
      this.passedConfig.manyErrors.push(new ErrorFormatter());
    } else {
      const addForm = () => {
        this.passedConfig.models.push(model);
        this.passedConfig.manyErrors.push(new ErrorFormatter());
      };

      console.log(model);
      this.saveBeforeCreatingForm.emit(addForm); // Save all form first before addng new form
    }
  }

  remove(index: any) {
    const models = [...this.passedConfig.models];
    const manyErrors = [...this.passedConfig.manyErrors];

    models.splice(index, 1);
    manyErrors.splice(index, 1);

    this.passedConfig.models = [...models];
    this.passedConfig.manyErrors = [...manyErrors];
  }

  generateButtonClass() {
    return 'fa fas fa-' + this.passedConfig.icon;
  }
}
